import jQuery from "jquery";
import '../plugins/responsiveHelper';
import 'slick-carousel';

export default function initAjaxPosts() {

  function reInitFunctionality (holder) {
    const imageSlider = holder.find('.images-slider');

    imageSlider.each(function(){ 
		const slider = jQuery(this);
		const controlsBox = jQuery('<div class="slider-pagination">');
		  slider.on('init', function(event, swiper) {
        controlsBox.insertBefore(swiper.$dots);
        controlsBox.append(swiper.$prevArrow).append(swiper.$dots).append(swiper.$nextArrow)

      });

      slider.slick({
        slidesToScroll: 1,
        rows: 0,
        slidesToShow: 1,
        infinite: false,
        dots: true,
        dotsClass: 'slick-dots',
        prevArrow: '<button class="slick-prev"><svg width="20" height="7" viewBox="0 0 20 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 3.19772L1 3.19772M1 3.19772L8.73441 0.913147M1 3.19772L7.76267 6.16791" stroke-width="1.24206" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow: '<button class="slick-next"><svg width="20" height="7" viewBox="0 0 20 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 3.19772L19 3.19772M19 3.19772L11.2656 0.913147M19 3.19772L12.2373 6.16791" stroke-width="1.24206" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
      });

	  });

    const jsSlider = holder.find('.js-slider');
    if(jsSlider.length) {
      jsSlider.each(function(){
        const slider = jQuery(this);
        ResponsiveHelper.addRange({
          '..1023': {
            on: function () {
              slider.slick({
                slidesToScroll: 1,
                rows: 0,
                arrows: false,
                dots: true,
                dotsClass: 'slick-dots',
                infinite: true,
                // adaptiveHeight: true,
                pauseOnHover: false,
                responsive: [
                  {
                    breakpoint: 2400,
                    settings: "unslick"
                  },
                  {
                    breakpoint: 1023,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1,
                    }
                  },
                  {
                    breakpoint: 767,
                    settings: {
                      adaptiveHeight: true,
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
                ]
              });
      
      
            },
            off: function () {
              slider.slick('unslick');
            }
          }
        });
      });

    }
  }

  jQuery('.ajax-container').each(function() {
    const container = jQuery(this);
    const content = container.find('.ajax-content');
    const form = container.find('[data-form]')
    const selects = form.find('[data-filter-select]');
    const formOpener = form.find('.btn-opener');
    const fromDatepicker = form.find('.from-datepicker');
    const toDatepicker = form.find('.to-datepicker');
    const selectedClass = 'selected bg-beige-200 alpha-50';
    const defaultClass = 'bg-beige';
    const inputGuests = form.find('input[data-guests-input]');
    const filterLinks = container.find('.filter-navigation a');
    const guestsResult = container.find('[data-guests-result]');
    let url, data, prevFilterIndex, defaultOpenerText, maxGuests, messageText;

    if(selects.length) {
      selects.on('change', function() {
        form.trigger('submit')
      });

    }

    if(formOpener.length) {
      defaultOpenerText = formOpener.text();
    }

    if(inputGuests.length && guestsResult.length) {
      maxGuests = guestsResult.data('guests-result') || 5;

      messageText = guestsResult.closest('.message-text');

      if(messageText.length) {
        messageText.addClass('d-none');
      }

      function findRooms() {
        let rooms = 1;
        let value = 0;
        inputGuests.each(function(){
          value += parseFloat(jQuery(this).val());
        });
        if(value > maxGuests) {
          if(value % maxGuests > 0) {
            rooms =  Math.ceil(value / maxGuests);
          } else {
            rooms =  value / maxGuests;
          }

          if(messageText.length) {
            messageText.removeClass('d-none');
          }
        } else {
          messageText.addClass('d-none');
        }


        guestsResult.text(rooms)



      }

      findRooms()

      inputGuests.on('change-value', function(e){
        findRooms();
      });

    }

    filterLinks.each(function(i){
      const link = jQuery(this);
      const item = link.closest('li');

      if(item.hasClass('active')) {
        prevFilterIndex = i;
      }

      link.on('click', function(e) {
        e.preventDefault();

        if(i === prevFilterIndex) return;
        url = link.attr('href');
        ajaxLoad(`${url}?ajax=1`);
        item.addClass('active');
        filterLinks.eq(prevFilterIndex).closest('li').removeClass('active')
        prevFilterIndex = i;
      })


    });
    function numToString(value) {
     return value< 10 ? `0${value}` : value; 
    }
    function changeOpener () {
      let from = 'from';
      let to = 'to';
      let fDate, tDate;
      
      if( fromDatepicker.val()) {
        fDate = new Date(fromDatepicker.val());
        from = `${numToString(fDate.getMonth())}/${numToString(fDate.getDate())}/${fDate.getFullYear()}`;
      }
      if( toDatepicker.val()) {
        tDate = new Date(toDatepicker.val());
        to = `${numToString(tDate.getMonth())}/${numToString(tDate.getDate())}/${tDate.getFullYear()}`;
      }
      formOpener.text(`${from} - ${to}`);
    }
    

    function ajaxLoad(url, data) {
      jQuery.ajax({
        // type: "POST",
        type: "GET",
        url,
        data: data,
        dataType: "HTML",
        success: function (response) {
          content.fadeOut(300, function() {
            content.empty();
            content.append(response);
            content.fadeIn(300);
            if(formOpener.length && fromDatepicker.length && toDatepicker.length) {
              changeOpener();
            }
            reInitFunctionality(content);
          });

        }, error: function(error) {
          console.error(error)
        }
      });
    }

    form.on('submit', function(e){
      e.preventDefault();
      data = form.serialize();
      url = form.attr('action');
      ajaxLoad(url, data);
    });

    content.on('click', '.pagination a', function(e){
      e.preventDefault();
      const link = jQuery(e.currentTarget);
      if(link.hasClass('active') || link.closest('.page-item').hasClass('active')) return;
      url = link.attr('href');
      jQuery('html, body').animate({
        scrollTop: content.closest('section').offset().top - jQuery('.header').innerHeight()
      });

      ajaxLoad(url, null);
    });
  

    function selectedBlock(e) {
      e.preventDefault();
      const link = jQuery(e.currentTarget)
      const block = link.closest('.open-block');

      if(block.hasClass('selected')) {
        block.removeClass(selectedClass).addClass(defaultClass);
      } else {
        block.addClass(selectedClass).removeClass(defaultClass);

      }
    }
    content.on('click', '.open-block .select, .open-block .remove', selectedBlock);
  });

  
}